import { render, staticRenderFns } from "./changeAddressDialog.vue?vue&type=template&id=1a473401&"
import script from "./changeAddressDialog.vue?vue&type=script&lang=js&"
export * from "./changeAddressDialog.vue?vue&type=script&lang=js&"
import style0 from "./changeAddressDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports